<div class="dailyhighlights">
    <div class="glancetitle center">
        Daily Highlights
    </div>
   
    <div>
        <div>

            <a *ngIf="!expanditem" (click)="expanditem = !expanditem"><i class="fa-solid fa-circle-plus fa-lg"></i><span
                    class="timeslot">9:00 AM <span class="activityname">Astoria Column Exploration</span></span></a>
            <a *ngIf="expanditem" (click)="expanditem = !expanditem"><i class="fa-solid fa-circle-minus fa-lg"></i><span
                    class="timeslot">9:00 AM <span class="activityname">Astoria Column Exploration</span></span></a>
        </div>
        <div class="row innerexpand" *ngIf="expanditem">
            <div class="col-6">
                <div class="activitypic">
                    <img src="/assets/images/crewbioimages/captain.png" class="img-fluid" alt="...">
                </div>

            </div>
            <div class="col-6">
                <div class="activitydesc">Matt Kelley</div>


            </div>
            <div class="activitylocationinfo">
                <span class="activitylocation">River Lounge</span>|
                <span class="activityDeck">Deck 2</span>
            </div>

        </div>
    </div>
</div>